var defaultStyles = {
  "root": "Base-Accordion",
  "item": "Base-Accordion--Item",
  "default": "Base-Accordion--Default",
  "contained": "Base-Accordion--Contained",
  "filled": "Base-Accordion--Filled",
  "separated": "Base-Accordion--Separated",
  "active": "Base-Accordion--Active",
  "accordion_item_header": "Base-Accordion--AccordionItemHeader",
  "control": "Base-Accordion--Control",
  "control_right": "Base-Accordion--ControlRight",
  "control_left": "Base-Accordion--ControlLeft",
  "content": "Base-Accordion--Content",
  "expanded": "Base-Accordion--Expanded",
  "content_inner": "Base-Accordion--ContentInner",
  "disabled": "Base-Accordion--Disabled",
  "control_disabled": "Base-Accordion--ControlDisabled",
  "title": "Base-Accordion--Title",
  "extra": "Base-Accordion--Extra",
  "icon": "Base-Accordion--Icon"
};

export { defaultStyles as default };
